import { render, staticRenderFns } from "./topUpPay.vue?vue&type=template&id=67b34127&scoped=true"
import script from "./topUpPay.vue?vue&type=script&lang=js"
export * from "./topUpPay.vue?vue&type=script&lang=js"
import style0 from "./topUpPay.vue?vue&type=style&index=0&id=67b34127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b34127",
  null
  
)

export default component.exports